import { createRoot } from 'react-dom/client';
import App from './app/App';
import { LanguageProvider } from './context/LanguageContext'; // Убедитесь, что путь к файлу корректный

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

root.render(
  <LanguageProvider>
    <App />
  </LanguageProvider>
);
